import styled, { css } from 'styled-components';
import { math } from 'polished';

interface HeadingProps {
    readonly noMargin?: boolean;
}
export const Heading = styled.h1<HeadingProps>`
    ${({ theme, noMargin }) => css`
        font-size: ${theme.typography.heading.sm};
        text-transform: uppercase;
        font-family: ${theme.typography.fontFamily};
        font-weight: 500;
        color: currentColor;
        margin: 0 0 8px 0;
        line-height: ${math(`${theme.typography.heading.sm} + 2px`)};
        letter-spacing: 1.5px;

        ${noMargin &&
        css`
            margin-bottom: 0;
        `}

        @media (min-width: ${theme.breakpoints.sm}px) {
            margin: 0 0 10px 0;
            font-size: ${theme.typography.heading.lg};
            line-height: ${math(`${theme.typography.heading.lg} + 3px`)};

            ${noMargin &&
            css`
                margin-bottom: 0;
            `}
        }
    `}
`;
export const SubHeading = styled.h2`
    ${({ theme }) => css`
        font-size: ${theme.typography.subHeading.sm};
        line-height: ${math(`${theme.typography.subHeading.sm} + 2px`)};
        color: currentColor;
        margin: 0 0 8px 0;
        text-transform: uppercase;
        font-family: ${theme.typography.fontFamily};

        @media (min-width: ${theme.breakpoints.sm}px) {
            margin: 0 0 24px 0;
            font-size: ${theme.typography.subHeading.lg};
            line-height: ${math(`${theme.typography.subHeading.lg} + 3px`)};
        }
    `}
`;

export const Tagline = styled.h3`
    ${({ theme }) => css`
        font-size: ${theme.typography.tagline.sm};
        line-height: ${math(`${theme.typography.tagline.sm} + 2px`)};
        color: currentColor;
        margin: 0 0 8px 0;

        @media (min-width: ${theme.breakpoints.sm}px) {
            margin: 0 0 16px 0;
            font-size: ${theme.typography.tagline.lg};
            line-height: ${math(`${theme.typography.tagline.lg} + 3px`)};
        }
    `}
`;

export const Byline = styled.p`
    font-size: 12px;
    line-height: 14px;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 0;
    margin-top: 24px;
    font-weight: 300;
`;
export const Spacer = styled.div`
    display: block;
    height: 24px;
    width: 100%;
`;
